import type { Language } from '@seek/melways-sites';
import {
  Box,
  IconEducation,
  IconGlobe,
  IconLocation,
  Stack,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import type { FC } from 'react';

import { convertLocationsIntoCommaList } from 'src/components/app/JobSection/utils';

import type { JobApplicationCardProps } from '../JobApplicationCard';

export const ProfileKeyInfo: FC<
  Pick<
    JobApplicationCardProps,
    'education' | 'homeLocation' | 'nationalities'
  > & { language: Language }
> = ({ education, homeLocation, nationalities, language }) => {
  const homeLocationInfo = homeLocation?.description ? (
    <Text size="small" icon={<IconLocation />}>
      {homeLocation.description}
    </Text>
  ) : null;

  const nationalitiesInfo =
    nationalities && nationalities.length > 0 ? (
      <Text size="small" icon={<IconGlobe />}>
        {convertLocationsIntoCommaList(nationalities, language)}
      </Text>
    ) : null;

  const educationInfo =
    education && education.name !== '' ? (
      <TooltipRenderer
        id="tooltip-profile-details"
        tooltip={<Text>{education.institute}</Text>}
      >
        {({ triggerProps }) => (
          <Box {...triggerProps} maxWidth="content">
            <Text size="small" icon={<IconEducation />}>
              {education.completionYear
                ? `${education?.name}, ${education?.completionYear}`
                : education?.name}
            </Text>
          </Box>
        )}
      </TooltipRenderer>
    ) : null;

  return (
    <>
      {homeLocationInfo || nationalitiesInfo || educationInfo ? (
        // FIXME: NVL - change to space="small"
        <Stack space="medium">
          {homeLocationInfo}
          {nationalitiesInfo}
          {educationInfo}
        </Stack>
      ) : null}
    </>
  );
};
